import React from 'react';
import { ArrowDownRight, ArrowUpRight } from 'lucide-react';
import { cn } from '../../lib/utils';

export default function StatCard({ label, value, sub, icon: Icon, color, trend, className }) {
  return (
    <div className={cn('p-5 rounded-xl bg-white border border-shell-border', className)}>
      <div className="flex items-start justify-between mb-3">
        <div
          className="w-9 h-9 rounded-lg flex items-center justify-center"
          style={{ backgroundColor: `${color}1A` }}>
          <Icon className="w-4 h-4" style={{ color }} />
        </div>
        {trend != null && (
          <span
            className={cn(
              'flex items-center gap-0.5 text-[11px] font-medium',
              trend >= 0 ? 'text-[#10B981]' : 'text-[#EF4444]',
            )}>
            {trend >= 0 ? <ArrowUpRight className="w-3 h-3" /> : <ArrowDownRight className="w-3 h-3" />}
            {Math.abs(trend).toFixed(1)}%
          </span>
        )}
      </div>
      <p className="text-2xl font-bold text-ink">{value}</p>
      <p className="text-xs text-mute mt-1">{label}</p>
      {sub ? <p className="text-[10px] text-mute mt-0.5">{sub}</p> : null}
    </div>
  );
}
